// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const DbmgrCloudProvider = {
  CloudProviderGCP: 'gcp',
  CloudProviderAWS: 'aws',
  CloudProviderAzure: 'azure',
} as const;
export type DbmgrCloudProvider =
  (typeof DbmgrCloudProvider)[keyof typeof DbmgrCloudProvider];

export function instanceOfDbmgrCloudProvider(value: any): boolean {
  for (const key in DbmgrCloudProvider) {
    if (Object.prototype.hasOwnProperty.call(DbmgrCloudProvider, key)) {
      if (
        DbmgrCloudProvider[key as keyof typeof DbmgrCloudProvider] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function DbmgrCloudProviderFromJSON(json: any): DbmgrCloudProvider {
  return DbmgrCloudProviderFromJSONTyped(json, false);
}

export function DbmgrCloudProviderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DbmgrCloudProvider {
  return json as DbmgrCloudProvider;
}

export function DbmgrCloudProviderToJSON(
  value?: DbmgrCloudProvider | null,
): any {
  return value as any;
}

export function DbmgrCloudProviderToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): DbmgrCloudProvider {
  return value as DbmgrCloudProvider;
}
